package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.AddReactionW500Rounded: ImageVector
    get() {
        if (_addReactionW500Rounded != null) {
            return _addReactionW500Rounded!!
        }
        _addReactionW500Rounded = Builder(name = "AddReactionW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(480.0f, 480.0f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.35f, -32.1f)
                quadToRelative(-74.43f, -32.1f, -129.51f, -87.17f)
                quadToRelative(-55.07f, -55.08f, -87.17f, -129.51f)
                quadToRelative(-32.1f, -74.44f, -32.1f, -159.35f)
                reflectiveQuadToRelative(32.1f, -159.35f)
                quadToRelative(32.1f, -74.43f, 87.17f, -129.51f)
                quadToRelative(55.08f, -55.07f, 129.51f, -87.17f)
                quadToRelative(74.44f, -32.1f, 159.35f, -32.1f)
                quadToRelative(30.13f, 0.0f, 59.5f, 4.4f)
                reflectiveQuadToRelative(56.98f, 12.97f)
                quadToRelative(25.39f, 7.76f, 32.59f, 25.05f)
                quadToRelative(7.19f, 17.3f, 2.19f, 34.21f)
                reflectiveQuadToRelative(-20.17f, 27.21f)
                quadToRelative(-15.18f, 10.29f, -35.29f, 3.05f)
                quadToRelative(-23.13f, -7.56f, -46.64f, -11.73f)
                quadToRelative(-23.51f, -4.16f, -49.16f, -4.16f)
                quadToRelative(-131.8f, 0.0f, -224.47f, 92.54f)
                quadToRelative(-92.66f, 92.55f, -92.66f, 224.59f)
                quadToRelative(0.0f, 132.04f, 92.66f, 224.59f)
                quadTo(348.2f, 797.13f, 480.0f, 797.13f)
                reflectiveQuadToRelative(224.47f, -92.54f)
                quadToRelative(92.66f, -92.55f, 92.66f, -224.59f)
                quadToRelative(0.0f, -14.89f, -1.52f, -30.02f)
                quadToRelative(-1.52f, -15.13f, -4.81f, -29.26f)
                quadToRelative(-4.28f, -22.11f, 7.63f, -35.43f)
                quadToRelative(11.92f, -13.31f, 28.83f, -16.31f)
                quadToRelative(16.91f, -3.0f, 32.85f, 5.93f)
                quadToRelative(15.93f, 8.94f, 20.69f, 31.85f)
                quadToRelative(4.05f, 17.61f, 5.69f, 35.86f)
                quadToRelative(1.64f, 18.25f, 1.64f, 37.38f)
                quadToRelative(0.0f, 84.91f, -32.1f, 159.35f)
                quadToRelative(-32.1f, 74.43f, -87.17f, 129.51f)
                quadToRelative(-55.08f, 55.07f, -129.51f, 87.17f)
                quadToRelative(-74.44f, 32.1f, -159.35f, 32.1f)
                close()
                moveTo(794.5f, 205.5f)
                horizontalLineToRelative(-38.09f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                reflectiveQuadToRelative(13.18f, -32.33f)
                quadToRelative(13.17f, -13.17f, 32.32f, -13.17f)
                horizontalLineToRelative(38.09f)
                verticalLineToRelative(-38.09f)
                quadToRelative(0.0f, -19.15f, 13.17f, -32.32f)
                quadToRelative(13.18f, -13.18f, 32.33f, -13.18f)
                reflectiveQuadToRelative(32.33f, 13.18f)
                quadToRelative(13.17f, 13.17f, 13.17f, 32.32f)
                verticalLineToRelative(38.09f)
                horizontalLineToRelative(38.09f)
                quadToRelative(19.15f, 0.0f, 32.32f, 13.17f)
                quadToRelative(13.18f, 13.18f, 13.18f, 32.33f)
                reflectiveQuadToRelative(-13.18f, 32.33f)
                quadToRelative(-13.17f, 13.17f, -32.32f, 13.17f)
                lineTo(885.5f, 205.5f)
                verticalLineToRelative(38.09f)
                quadToRelative(0.0f, 19.15f, -13.17f, 32.32f)
                quadToRelative(-13.18f, 13.18f, -32.33f, 13.18f)
                reflectiveQuadToRelative(-32.33f, -13.18f)
                quadToRelative(-13.17f, -13.17f, -13.17f, -32.32f)
                verticalLineToRelative(-38.09f)
                close()
                moveTo(618.09f, 441.91f)
                quadToRelative(25.95f, 0.0f, 43.93f, -17.98f)
                quadTo(680.0f, 405.96f, 680.0f, 380.0f)
                reflectiveQuadToRelative(-17.98f, -43.93f)
                quadToRelative(-17.98f, -17.98f, -43.93f, -17.98f)
                quadToRelative(-25.72f, 0.0f, -43.7f, 18.09f)
                quadToRelative(-17.98f, 18.1f, -17.98f, 43.82f)
                reflectiveQuadToRelative(17.98f, 43.82f)
                quadToRelative(17.98f, 18.09f, 43.7f, 18.09f)
                close()
                moveTo(341.91f, 441.91f)
                quadToRelative(25.72f, 0.0f, 43.7f, -18.09f)
                quadToRelative(17.98f, -18.1f, 17.98f, -43.82f)
                reflectiveQuadToRelative(-17.98f, -43.82f)
                quadToRelative(-17.98f, -18.09f, -43.7f, -18.09f)
                quadToRelative(-25.95f, 0.0f, -43.93f, 17.98f)
                quadTo(280.0f, 354.04f, 280.0f, 380.0f)
                reflectiveQuadToRelative(17.98f, 43.93f)
                quadToRelative(17.98f, 17.98f, 43.93f, 17.98f)
                close()
                moveTo(480.0f, 700.0f)
                quadToRelative(58.72f, 0.0f, 108.2f, -28.6f)
                quadToRelative(49.47f, -28.6f, 79.23f, -77.55f)
                quadToRelative(6.0f, -12.48f, -1.23f, -24.6f)
                quadToRelative(-7.24f, -12.12f, -21.48f, -12.12f)
                lineTo(315.28f, 557.13f)
                quadToRelative(-14.24f, 0.0f, -21.48f, 12.0f)
                quadToRelative(-7.23f, 12.0f, -1.23f, 24.48f)
                quadToRelative(29.76f, 48.96f, 79.61f, 77.67f)
                quadTo(422.04f, 700.0f, 480.0f, 700.0f)
                close()
            }
        }
        .build()
        return _addReactionW500Rounded!!
    }

private var _addReactionW500Rounded: ImageVector? = null
